/* PROVEN — theme.js */
(function () {
  'use strict';

  /* ── toast ───────────────────────────────── */
  var toast = document.getElementById('toast'), tTimer;
  window.provenToast = function (msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(tTimer);
    tTimer = setTimeout(function () { toast.classList.remove('show'); }, 2800);
  };

  function press(group, btn) {
    group.querySelectorAll('[aria-pressed]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    btn.setAttribute('aria-pressed', 'true');
  }

  /* ── burger menu ─────────────────────────── */
  var navbar = document.getElementById('navbar');
  var burger = document.getElementById('burger');
  function closeMenu() {
    if (!navbar) return;
    navbar.classList.remove('open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
  }
  if (burger && navbar) {
    burger.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = navbar.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var menu = document.getElementById('menu');
    if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('a')) closeMenu(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
    document.addEventListener('click', function (e) {
      if (navbar.classList.contains('open') && !e.target.closest('#navbar')) closeMenu();
    });
  }

  /* ── colorway plates: hover flips to back ─── */
  document.querySelectorAll('[data-plate]').forEach(function (card) {
    var img = card.querySelector('img');
    var front = card.dataset.front, back = card.dataset.back;
    if (!img || !back) return;
    card.addEventListener('mouseenter', function () { img.src = back; });
    card.addEventListener('mouseleave', function () { img.src = front; });
  });

  /* ── collection view toggle (grid / record) ─ */
  var viewToggle = document.getElementById('viewtoggle');
  if (viewToggle) {
    var host = document.getElementById('plp');
    viewToggle.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !host) return;
      press(viewToggle, b);
      host.className = b.dataset.view === 'grid' ? 'grid' : 'rows';
      host.querySelectorAll('[data-card]').forEach(function (n) {
        n.hidden = (n.dataset.card !== b.dataset.view);
      });
      try { localStorage.setItem('proven_view', b.dataset.view); } catch (err) {}
    });
    try {
      var saved = localStorage.getItem('proven_view');
      if (saved) {
        var b = viewToggle.querySelector('[data-view="' + saved + '"]');
        if (b) b.click();
      }
    } catch (err) {}
  }

  /* ── product: variant picker ─────────────── */
  var pdp = document.getElementById('pdp');
  if (pdp) {
    var data = document.getElementById('variant-data');
    var variants = data ? JSON.parse(data.textContent) : [];
    var idInput = document.getElementById('variant-id');
    var priceEl = document.getElementById('pdp-price');
    var addBtn = document.getElementById('add-btn');
    var buyBtn = document.getElementById('buy-btn');
    var soldNote = document.getElementById('sold-note');
    var colorLabel = document.getElementById('color-name');

    function selected(name) {
      var g = pdp.querySelector('[data-option="' + name + '"]');
      if (!g) return null;
      var b = g.querySelector('[aria-pressed="true"]');
      return b ? b.dataset.value : null;
    }

    function match() {
      var o1 = selected('option1'), o2 = selected('option2'), o3 = selected('option3');
      return variants.filter(function (v) {
        return (o1 === null || v.option1 === o1) &&
               (o2 === null || v.option2 === o2) &&
               (o3 === null || v.option3 === o3);
      })[0];
    }

    function showImageFor(value) {
      var media = pdp.querySelectorAll('[data-media-alt]');
      var main = document.getElementById('gal-img');
      if (!main || !value) return;
      for (var i = 0; i < media.length; i++) {
        if ((media[i].dataset.mediaAlt || '').indexOf(value) > -1) {
          main.src = media[i].dataset.src;
          main.alt = media[i].dataset.mediaAlt;
          pdp.querySelectorAll('.thumbs button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          if (media[i].tagName === 'BUTTON') media[i].setAttribute('aria-pressed', 'true');
          return;
        }
      }
    }

    function sync() {
      var v = match();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailable; }
        if (buyBtn) buyBtn.disabled = true;
        if (soldNote) soldNote.hidden = false;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price_formatted;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.innerHTML = v.available
          ? addBtn.dataset.label + ' <span class="arrow">&#8592;</span>'
          : addBtn.dataset.soldout;
      }
      if (buyBtn) buyBtn.disabled = !v.available;
      if (soldNote) soldNote.hidden = v.available;
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
    }

    pdp.querySelectorAll('[data-option]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        press(group, b);
        if (group.dataset.option === 'option1') {
          if (colorLabel) colorLabel.textContent = b.dataset.value;
          showImageFor(b.dataset.value);
        }
        sync();
      });
    });

    pdp.querySelectorAll('.thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        var main = document.getElementById('gal-img');
        if (!main) return;
        main.src = b.dataset.src;
        main.alt = b.dataset.mediaAlt || '';
        pdp.querySelectorAll('.thumbs button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        var cap = document.getElementById('gal-cap');
        if (cap && b.dataset.cap) cap.textContent = b.dataset.cap;
      });
    });

    var qv = document.getElementById('qty-val');
    var qi = document.getElementById('qty-input');
    var minus = document.getElementById('q-minus'), plus = document.getElementById('q-plus');
    function setQty(n) {
      n = Math.max(1, n);
      if (qv) qv.textContent = n;
      if (qi) qi.value = n;
    }
    if (minus) minus.addEventListener('click', function () { setQty(parseInt(qi.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(parseInt(qi.value, 10) + 1); });

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var form = document.getElementById('product-form');
        if (!form) return;
        var flag = document.createElement('input');
        flag.type = 'hidden'; flag.name = 'checkout'; flag.value = '1';
        form.appendChild(flag);
        form.submit();
      });
    }

    sync();
  }

  /* ── cart: auto-submit on quantity change ── */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
  document.querySelectorAll('[data-qty-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.qty');
      var input = wrap ? wrap.querySelector('input') : null;
      if (!input) return;
      var n = parseInt(input.value, 10) + parseInt(btn.dataset.qtyStep, 10);
      input.value = Math.max(0, n);
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ── contact form: friendly validation ───── */
  var cform = document.getElementById('contact-form');
  if (cform) {
    cform.addEventListener('submit', function (e) {
      var name = cform.querySelector('[name="contact[name]"]');
      var body = cform.querySelector('[name="contact[body]"]');
      if ((name && !name.value.trim()) || (body && !body.value.trim())) {
        e.preventDefault();
        window.provenToast('اكتب الاسم والرسالة عشان نقدر نرد');
      }
    });
  }
})();
